import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Checkout from "./components/Checkout";
import EnterBalance from "./components/EnterBalance";
import Init from "./components/Init";
import PageNotFound from "./components/NotFound";
import Success from "./components/Success";
import { ContextProvider } from "./context/Context";

function App() {
  return (
    <BrowserRouter>
      <ContextProvider>
        <Routes>
          <Route exact path="/:storeID" element={<Init />} />
          <Route path="/not-found" element={<PageNotFound />} />
          <Route path="/enter-balance" element={<EnterBalance />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/success" element={<Success />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </ContextProvider>
    </BrowserRouter>
  );
}

export default App;
